export default "__VITE_ASSET__CHnU7dBS__"